import { FormattedMessage } from 'react-intl';

import Tag from '@/designSystem/Tag/Tag';

import messages from './messages';

import useStyles from './styles';

const QuickAnswer = () => {
  const { classes } = useStyles();

  return (
    <Tag
      icon="lightningBolt"
      iconColor="neutralEmphasis"
      size="medium"
      variant="rounded"
      label={<FormattedMessage {...messages.answer} />}
      className={classes.container}
    />
  );
};

export default QuickAnswer;
